import { useMemo } from 'react'
import { useUser } from '../providers/UserProvider'
import { useClientOptions } from '../providers/ClientOptionsProvider'

// User related permissions hook
export const useUserPermissions = () => {
  const { isAdmin } = useClientOptions()
  const { hasPermissions = () => isAdmin, user } = useUser()

  const permissionToViewAllQuotes = hasPermissions(['read:all-quotes'])
  const permissionToCreateQuote = hasPermissions(['create:quotes'])
  const permissionToCreateInvoice = hasPermissions(['create:invoices'])
  const permissionToCreateContact = hasPermissions(['create:contacts'])
  const permissionToCreateCompany = hasPermissions(['create:companies'])
  const permissionToCreateDeal = hasPermissions(['create:deals'])
  const permissionToCreateEvent = hasPermissions(['create:events'])
  const permissionToCreateTask = hasPermissions(['create:tasks'])

  const permissionToSendAssignedQuote = hasPermissions(['send:assigned-quotes'])
  const permissionToEditAssignedQuote = hasPermissions(['write:assigned-quotes'])
  const permissionToEditAllQuote = hasPermissions(['write:all-quotes'])
  const permissionToSendAllQuote = hasPermissions(['send:all-quotes'])
  const permissionToSendAssignedInvoice = hasPermissions(['send:assigned-invoices'])
  const permissionToSendAllInvoice = hasPermissions(['send:all-invoices'])
  const permissionToEditAssignedInvoice = hasPermissions(['write:assigned-invoices'])
  const permissionToEditAllInvoice = hasPermissions(['write:all-invoices'])

  const permissionToEditAllCompanies = hasPermissions(['write:all-companies'])
  const permissionToEditAssignedCompanies = hasPermissions(['write:assigned-companies'])

  const permissionToEditAllContacts = hasPermissions(['write:all-contacts'])
  const permissionToEditAssignedContacts = hasPermissions(['write:assigned-contacts'])

  const permissionToEditAllDeals = hasPermissions(['write:all-deals'])
  const permissionToEditAssignedDeals = hasPermissions(['write:assigned-deals'])

  const permissionToEditAllEvents = hasPermissions(['write:all-events'])
  const permissionToEditAssignedEvents = hasPermissions(['write:assigned-events'])

  const permissionToEditAllTasks = hasPermissions(['write:all-tasks'])
  const permissionToEditAssignedTasks = hasPermissions(['write:assigned-tasks'])

  const permissionToEditAccountSettings = hasPermissions(['write:account-settings'])

  const permissionToViewEstimator = hasPermissions(['read:estimator-select'])

  return useMemo(
    () => ({
      permissionToViewAllQuotes,
      permissionToCreateQuote,
      permissionToCreateInvoice,
      permissionToSendAssignedQuote,
      permissionToEditAssignedQuote,
      permissionToEditAllQuote,
      permissionToSendAllQuote,
      permissionToSendAssignedInvoice,
      permissionToSendAllInvoice,
      permissionToEditAssignedInvoice,
      permissionToEditAllInvoice,

      permissionToCreateContact,
      permissionToEditAllContacts,
      permissionToEditAssignedContacts,

      permissionToCreateCompany,
      permissionToEditAllCompanies,
      permissionToEditAssignedCompanies,

      permissionToCreateDeal,
      permissionToEditAllDeals,
      permissionToEditAssignedDeals,

      permissionToCreateTask,
      permissionToEditAllTasks,
      permissionToEditAssignedTasks,

      permissionToCreateEvent,
      permissionToEditAllEvents,
      permissionToEditAssignedEvents,

      permissionToEditAccountSettings,
      permissionToViewEstimator
    }),
    [user, hasPermissions]
  )
}
